import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Row, CardImg, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { dAPI_Delete_Ingetration, SALESFORCE, putAPI_Update_OnOff } from '../../../../../constants/APIs';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  faSalesforce,
  faStripe,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SalesforceIntegration from './SalesforceIntegration';
export default function WebIntegrationThumb({ integration, refreshConnection, allProperties, LoadIntegrations }) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(!integration.disabled);
  useEffect(() => {
    const result = integration.properties.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    // console.log(result)
    if (result.length > 2) {
      const filterResults = result.slice(0, 2);
      // console.log(filterResults)
      setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));
      setMoreProperties('and ' + (result.length - filterResults.length) + ' more')
    }
    else {
      const filterResults = result.filter(elem => elem !== undefined);
      //console.log(filterResults)
      setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));
    }

  }, [integration, allProperties]);
  const handleOnOff = (onoff) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff }
    })
      .then(res => {
        if (onoff) {
          refreshConnection("InActive");
        }
        else {
          refreshConnection("Active");
        }
      })
      ;
  };

  const handleSwitchChange = (value) => {
    setCheckedPrimarySmall(value);
    handleOnOff(!value)
  }

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = async (id, customerid) => {
    await AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
    })
      .then(res => {
        toggle();
        LoadIntegrations();
      })
      ;
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      {integration ?
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card className="d-flex flex-row" style={{ height: '215px' }}>
            <div>
              <h3 className="integrationChannel stripe-logo" style={{
                fontSize: '50px', fill: 'black',
                color: 'black'
              }}> <FontAwesomeIcon icon={faSalesforce}></FontAwesomeIcon> </h3>
              {/* <a href="#/" className="integrationremove"
                onClick={toggle}
              >
                {" "}
                <h3 className="iconsminds-remove" />{" "}
              </a> */}
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                checked={checkedPrimarySmall}
                onChange={(primary) => handleSwitchChange(primary)}
              />
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-3">
                  <Fragment key={integration.id}>
                    <div className="text-center">
                      <div className="mb-1">
                        {integration.botSettings ? integration.botSettings.name : ''}
                      </div>
                      <div className="mb-1">
                        {integration ? integration.name : null}
                      </div>
                      <div className="mb-1">
                        <b>{formatedProperties} </b>
                        <b>{moreProperties}</b><br />
                      </div>
                      {/* <div className="mb-2">
                        <b>{integration.channelDetails.clientId}</b>
                      </div> */}
                      <Button
                        size="xs"
                        color="success"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => setIsEditing(!isEditing)}
                      >
                        Edit
                      </Button>
                      <br />
                      <Button
                        size="xs"
                        color="danger"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={toggle}
                      >
                        Disconnect
                      </Button>
                    </div>
                  </Fragment>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx> : null
      }
      {isEditing ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <SalesforceIntegration
                  visible={isEditing}
                  toggle={() => {
                    setIsEditing(!isEditing);
                  }}
                  id={integration.id}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      {generateDeleteButton()}
    </Fragment >
  );
}
